import React, { useState, useEffect, useRef } from "react";
import { Nav, NavLink } from "../Allcss/NavbarElements";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Swal from 'sweetalert2';
import axios from 'axios';
import '../Allcss/nav.css'; 
import { BASE_URL } from "../../App";
import { useNavigate,useLocation } from "react-router-dom";
import { Backdrop, CircularProgress } from '@mui/material';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const containerRef = useRef(null);
  const MENU_NAME = localStorage.getItem("MENU_NAME");
  const login_id = localStorage.getItem("LOGIN_ID");



  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component is mounted or navigated to
  }, [location]); // Trigger scroll on route change

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.post(BASE_URL + '/mainMENUList', {
          login_id: login_id,
          "MENU_NAME": MENU_NAME,
        });
        console.log(response.data);
        setMenuItems(response.data.menulist);
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire({
          icon: "error",
          text: 'Failed to fetch menu items'
        });
      } finally {
        setLoading(false);
      }
    };

    if (!login_id) {
      Swal.fire({
        icon: "warning",
        text: 'Login Failed!'
      });
      navigate('/Login');
    } else {
      fetchData();
    }
  }, [login_id, MENU_NAME, navigate]);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const containerHeight = containerRef.current.clientHeight;
        const menuItemHeight = 40; // Approximate height of each menu item
        const totalMenuItems = menuItems.length;
        const itemsPerColumn = Math.floor(containerHeight / menuItemHeight);
        const columns = Math.ceil(totalMenuItems / itemsPerColumn);
        containerRef.current.style.columnCount = columns;
      }
    };

    handleResize(); // Initial call
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [menuItems]);

  const renderMenuItems = () => {
    const categorizedMenuItems = {};

    menuItems.forEach(menuItem => {
      if (!categorizedMenuItems[menuItem.category_name]) {
        categorizedMenuItems[menuItem.category_name] = [];
      }
      categorizedMenuItems[menuItem.category_name].push(menuItem);
    });

    return (
      <Box ref={containerRef} sx={{ maxHeight: '100%', wordWrap: 'break-word' }}>
        {Object.keys(categorizedMenuItems).map(category_name => (
          <Box
            key={category_name}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(8px)',
              marginBottom: '1rem',
              borderRadius: '10px',
              padding: '1rem',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.2)',
              breakInside: 'avoid'
            }}
          >
            <Typography variant="h6" sx={{ px: 2, pb: 1, fontWeight: 'bold', alignSelf: 'flex-start', color: 'white' }}>
              {category_name}
            </Typography>
            <Box display="flex" flexDirection="column" sx={{ px: 2, pb: 1, alignSelf: 'flex-start' }}>
              {categorizedMenuItems[category_name].map((menuItem) => (
                <NavLink key={menuItem.id} to={menuItem.urlpath}>
                  <i className={menuItem.icon} style={{ marginRight: '15px' }}></i>
                  <span className="menu-item" style={{ maxHeight: '2rem', overflow: 'hidden', display: 'inline-block', marginRight: '15px', fontSize: '1rem' }}>{menuItem.urlname}</span>
                </NavLink>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    );
  };

  return (
    <Nav sx={{ padding: 'auto' }}>
      {menuItems.length > 0 ? (
        renderMenuItems()
      ) : (
        <p></p>
      )}
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Nav>
  );
};

export default Navbar;
